let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("A7G4D")).then(() => parcelRequire('1uYpX'));